import cn from "classnames";
import style from "./style.module.css";

interface IAssessmentCardGridProps {
  className?: string;
  children: React.ReactNode;
}

export default function AssessmentTemplateCardGrid({ children, className }: IAssessmentCardGridProps) {
  return <div className={cn(style.grid, className)}>{children}</div>;
}
